// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dosiin_modal-categories #modals{top:125px!important;z-index:11!important;height:100vh!important;width:100%!important;background:unset!important;overflow-y:scroll;transition:all .2s ease-in-out}.modal.dosiin_modal-aside{height:100%!important;top:0}.dsi_header-tab-icon span{font-weight:600;font-size:14px;line-height:21px;color:#484848}", ""]);
// Exports
module.exports = exports;
